<template>
  <component
    :is="verification_component"
    :token="token"
    :redirectUri="redirectURI"
    @skip-click="onSkipClick"
  ></component>
</template>

<script setup lang="ts">
import { ref, markRaw } from 'vue'
import { useRoute } from 'vue-router'

// Types
import type { Component } from 'vue'

// Components
import EmailVerification from '@/components/EmailVerification/EmailVerification.vue'
import PhoneVerification from '@/components/PhoneVerification/PhoneVerification.vue'

// Assets
import { onMounted } from 'vue'

// Helpers
import { setAuthForm } from '@/api/api'

const route = useRoute()

const verification_components = ref<{ [key: string]: Component }>({
  email: EmailVerification,
  phone: PhoneVerification,
})

const verification_component = ref<Component | null>(null)
const verificationType = ref<string | null>(null)
const redirectURI = ref<string | null>(null)
const token = ref<string | null>(null)

function onSkipClick() {
  if (token.value) {
    setAuthForm(token.value).then(() => {
      const redirectURI = (route.query?.redirectUri || '') as string
      redirectURI && (window.location.href = redirectURI)
    })
  }
}

onMounted(() => {
  redirectURI.value = (route.query?.redirectUri || '') as string
  verificationType.value = (route.query?.type || '') as string
  token.value = (route.query?.token || '') as string

  if (verificationType.value) {
    const cmp = verification_components.value[verificationType.value]
    if (cmp) {
      verification_component.value = markRaw(cmp)
    }
  }
})
</script>

<style scoped lang="scss">
.verification-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
  }

  &__shape {
    height: 100%;
    flex-shrink: 0;
    width: 673px;
    background-image: url('@/assets/images/shape-background.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  @media screen and (max-width: 1365px) {
    &__shape {
      display: none;
    }
  }
}
</style>
